<template>
  <div class="timeSlots m-b-2">
    <div v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
    </div>
    <div class="text-xs-center" v-if="!loading && times.length === 0 && typeof selectedTimeIndex !== 'undefined'">
      {{t('This day is fully booked')}}
    </div>
    <div class="text-xs-center" v-if="!loading && times.length">
      <span v-if="times.length > 1">{{t('Available times for')}}</span>
      <span v-else>{{t('Available time for')}}</span>
      <span>{{humanDate(selectedDay)}}</span>:
    </div>
    <div class="text-xs-center m-t-1">
      <span v-for="(time, index) in times">
        <button class="btn btn-sm" v-bind:class="{'btn-primary': (index === selectedTimeIndex), 'btn-outline-primary': (index !== selectedTimeIndex)}" @click="setSelectedTimeIndex(index)">{{humanTime(time.date)}}</button>
      </span>
    </div>
  </div>
</template>


<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'TimeSlots',
    components: {
    },
    computed: {
      ...mapState({
        language: state => state.language,
        loading: state => state.publicCalendar.loadingTimes,
        times: state => state.publicCalendar.times,
        selectedTimeIndex: state => state.publicCalendar.selectedTimeIndex,
        selectedDay: state => state.publicCalendar.selectedDay,
        locales: state => state.locales,
      }),

    },
    methods: {
      ...mapActions({
        setSelectedTimeIndex: 'publicCalendar/setSelectedTimeIndex',
      }),
      humanTime(dateTime) {
        return window.moment(dateTime).format('HH:mm');
      },
      humanDate(date) {
        const weekday = this.locales[this.language].weekdaysShort[window.moment(date).format('d')];
        const monthDay = window.moment(date).format('D');
        const month = this.locales[this.language].monthNames[window.moment(date).format('M') - 1];

        return `${weekday}, ${monthDay} ${month}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* for $brand-primary */
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";
.btn-outline-primary {
  color: #222 !important;
}

.btn-outline-primary:hover {
  background: $brand-primary;
  color: white !important;
}
.btn-outline-primary:focus {
  background: white;
  color: #222;

}
</style>



// WEBPACK FOOTER //
// TimeSlots.vue?00d77f66